<section class="targeted-users-card" [class.targeted-users-card--embedded]="embedded()">
  <div class="targeted-users-card__header">
    <h2 class="targeted-users-card__title">{{ title() }}</h2>
    @if (description(); as description) {
      <p class="targeted-users-card__description">{{ description }}</p>
    }
  </div>

  <mat-radio-group class="targeted-users-card__list" [value]="scope()" (change)="onScopeChange($event.value)">
    @for (option of scope_options; track option) {
      <mat-radio-button class="targeted-users-card__item" [value]="option">
        {{ scope_labels[option] }}
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (is_manual()) {
    <mat-form-field appearance="outline" class="targeted-users-card__chips" [class.mat-form-field-invalid]="!!error_message()">
      <mat-label>Usuarios</mat-label>
      <mat-chip-grid #chipGrid aria-label="Usuarios seleccionados">
        @for (user of selection(); track user.id) {
          <mat-chip-row (removed)="removeUser(user.id)">
            {{ displayUserLabel(user) }}
            <button matChipRemove type="button" [attr.aria-label]="'Quitar ' + displayUserLabel(user)">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          #search_input
          placeholder="Buscar..."
          [formControl]="search_control"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="usersAutocomplete"
          (blur)="onUsersInputBlur($event)"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #usersAutocomplete="matAutocomplete"
        [displayWith]="display_search_value"
        (optionSelected)="onUserSelected($event)"
        (closed)="onSearchPanelClosed()"
      >
        @for (user of suggestions(); track user.id) {
          <mat-option [value]="user">{{ displayUserLabel(user) }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    @if (error_message(); as message) {
      <p class="targeted-users-card__error" role="alert">{{ message }}</p>
    }
  }
</section>
